{
  "name": "o30-client",
  "version": "2026.3.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "npm run before:build && sh -c \"ng serve --port 4300",
    "start:prod": "npm run before:build && sh -c \"ng serve --live-reload --host 0.0.0.0 --port 4300 --configuration production",
    "build": "npm run before:build && ng build --aot --configuration production --build-optimizer",
    "build:prod": "npm run before:build && ng build --configuration=production",
    "lint": "ng lint",
    "before:build": "ts-node ./startup/set-env.ts",
    "get:env": "node ./startup/env.js",
    "update:gsm:entities": "npm remove @gsm/entities && npm i --save @gsm/entities --save-exact",
    "install:with-local:gsm": "npm install && npm link @gsm/ui-lib-elements @gsm/ui-lib-ng-shared"
  },

  "private": true,
  "dependencies": {
    "@angular/animations": "19.2.10",
    "@angular/cdk": "19.2.15",
    "@angular/common": "19.2.10",
    "@angular/compiler": "19.2.10",
    "@angular/core": "19.2.10",
    "@angular/forms": "19.2.10",
    "@angular/material": "19.2.15",
    "@angular/platform-browser": "19.2.10",
    "@angular/platform-browser-dynamic": "19.2.10",
    "@angular/router": "19.2.10",
    "@angular/service-worker": "19.2.10",
    "@gsm/entities": "2.1.13",
    "@karl/theme": "0.3.12",
    "@material/layout-grid": "14.0.0",
    "@ng-dynamic-forms/core": "18.0.0",
    "@ngneat/until-destroy": "9.2.3",
    "@o30/entities": "8.0.3-makler35",
    "file-saver": "2.0.5",
    "html2canvas": "1.0.0-rc.7",
    "material-design-icons-iconfont": "6.7.0",
    "moment": "2.29.1",
    "ngx-device-detector": "6.0.2",
    "ngx-mask": "14.2.4",
    "ngx-mat-select-search": "7.0.4",
    "require": "2.4.20",
    "rxjs": "7.8.1",
    "stacktrace-js": "2.0.2",
    "symbol-observable": "1.2.0",
    "zone.js": "0.15.0"
  },
  "optionalDependencies": {
    "fsevents": "2.2.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.11",
    "@angular-devkit/core": "19.2.11",
    "@angular-eslint/builder": "19.4.0",
    "@angular-eslint/eslint-plugin": "19.4.0",
    "@angular-eslint/eslint-plugin-template": "19.4.0",
    "@angular-eslint/schematics": "19.4.0",
    "@angular-eslint/template-parser": "19.4.0",
    "@angular/cli": "19.2.11",
    "@angular/compiler-cli": "19.2.10",
    "@angular/language-service": "19.2.10",
    "@angular/material-moment-adapter": "19.2.15",
    "@ng-dynamic-forms/ui-material": "18.0.0",
    "@types/file-saver": "2.0.1",
    "@types/iban": "0.0.32",
    "@types/lodash": "4.14.178",
    "@types/node": "20.11.16",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "dotenv": "8.2.0",
    "eslint": "8.57.0",
    "fast-deep-equal": "3.1.3",
    "group-array": "1.0.0",
    "html-to-image": "0.1.1",
    "iban": "0.0.14",
    "lodash": "4.17.21",
    "moment": "2.29.1",
    "ngx-moment": "6.0.2",
    "ngx-window-token": "7.0.0",
    "prettier": "2.8.3",
    "raw-loader": "4.0.2",
    "sass": "1.49.0",
    "ts-node": "10.9.1",
    "typescript": "5.5.4"
  }
}
